import { List } from 'antd';
import React from 'react';
import { User } from 'src/interfaces/entities/user';
import EditUser from 'src/pages/administration/EditUser';

export default function ListUsers({ users, }: { users: User[] }) {
	return (
		<List
			itemLayout="horizontal"
			dataSource={users}
			renderItem={(item: User) => (
				<List.Item >
					<List.Item.Meta
						title={item.full_name}
						description={item.email}
					/>
					<EditUser initialUser={item} />
				</List.Item>
			)}
		/>
	);
}
